import api from '../../plugins/api';

// GET /crm/cars/getDcRequisites?dcId= — банковские и юридические реквизиты
// дилерского центра. Ими предзаполняется блок «Реквизиты» в договоре поручения.
// Ответ: { name, bin, iban, bankName, bic, kbe, address, directorName, directorBasis }
const getDcRequisites = (dcId) => {
  return api.get('/api/crm/cars/getDcRequisites', { dcId });
};

export default getDcRequisites;
